import {SmartfireBlockPageRenderer} from '@smartfire/js-block-engine';
import React from 'react';

if((<any>window).wp) {
    // Create WP proxy to avoid issues on ESModule imports
    (<any>window).wp = new Proxy((<any>window).wp, {
        get(target: any, p: string | symbol): any {
            if(target[p]) {
                return target[p];
            } else {
                if(p === "elements") {
                    return React;
                }
                return {}; // Empty Library
            }
        }
    });
}

const SmartfireWordpressPageRenderer = new SmartfireBlockPageRenderer();
(<any>window).SmartfireWordpressPageRenderer = SmartfireWordpressPageRenderer;

const hasDisableBlockEngineClass = document.body.classList.contains('disable-block-engine');
if(!hasDisableBlockEngineClass) {
    SmartfireWordpressPageRenderer.render();
} else {
    console.log('Smartfire Block Engine disabled');
}

export default SmartfireWordpressPageRenderer;